import * as React from 'react';
import { withStyles, WithStyles, StyleRules, ClassNameMap } from "@mui/styles";
import { CircularProgress } from '@mui/material';
import { Theme } from '@mui/styles';
import * as request from 'superagent';
import Dropzone from '~common/components/versioned-document-dropzone';
//import * as Dropzone from 'react-dropzone/dist/index';
import { red, green, grey } from '@mui/material/colors';
import { Icon } from '@mui/material';
import { IconButton } from '@mui/material';
import {
  Button,
  ListItemText,
  ListItemIcon,
  ListSubheader
} from '@mui/material';
import PortalUserContext from '~common/lib/portal-user-context';
import { Menu, MenuItem } from '@mui/material';
import * as moment from 'moment';
import { Tooltip } from '@mui/material';

const styles = (theme: Theme): StyleRules => ({
  text:{
    color: 'black'
  },
  container: {
    width: '100%',
    marginTop: '-3px'
  },
  document: {
    display: 'flex'
  },
  defaultDocument: {
    color: '#ccc'
  },
  deleteButton: {
    padding: 12
  },
  noDocument: {
    display: 'flex',
    'align-items': 'center',
    'justify-content': 'center',
    fontWeight: 500,
    color: '#ccc',
    marginLeft: 15,
    marginTop: 7
  },
  documentIcon: {
    padding: 5,
    cursor: 'pointer'
  },
  documentFileName: {
    padding: 5,
    paddingRight: 10,
    marginTop: 5,
    cursor: 'pointer',
    color: '#000'
  },
  dropzone: {
    border: '1px dashed #ccc',
    padding: 15,
    marginLeft: 10,
    marginTop: 0,
    backgroundColor: grey[100],
    flex: 'auto',
    display: 'flex',
    'align-items': 'center',
    'justify-content': 'center',
    cursor: 'pointer',
    minWidth: 240
  },
  dropzoneError: {
    border: '1px dashed #ccc',
    padding: 15,
    marginLeft: 10,
    marginTop: 0,
    backgroundColor: red[100],
    flex: 'auto',
    display: 'flex',
    'align-items': 'center',
    'justify-content': 'center',
    cursor: 'pointer',
    minWidth: 240
  },
  dropzoneMin: {
    border: '0px dashed #ccc',
    paddingTop: 8,
    marginLeft: 10,
    marginTop: 0,
    // backgroundColor: grey[100],
    width: '2rem',
    height: '2rem',
    display: 'flex',
    'align-items': 'center',
    'justify-content': 'center',
    cursor: 'pointer'
  },
  dropzoneActive: {
    backgroundColor: green[100]
  },
  dropzoneReject: {
    backgroundColor: red[100]
  },
  dropzoneDisabled: {
    backgroundColor: grey[400]
  },
  required: {
    color: "red",
    fontWieght: 600,
    fontSize: "0.85rem"
  },
  error: {
    backgroundColor: red[100]
  },
  loading: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 44,
    minHeight: 44
  },
  listArea: {
    display: 'flex',
    alignContent: 'flex-start',
    alignItems: 'center'
  },
  subheader: {
    userSelect: 'none',
    lineHeight: 2.5,
    '&:focus': {
      outlineWidth: 0
    },
    backgroundColor: '#fff'
  },
  compactLabel: {
    fontSize: '0.75rem'
  }
});

var MAX_FILE_SIZE = 5242880;

interface Props extends React.HTMLProps<HTMLDivElement> {
  dissallowNewVersions?: boolean;
  multiple?: boolean;
  preventDelete?: boolean;
  hideVersions?: boolean;
  suppressApiDelete?: boolean;
  alwaysOpenInNewWindow?: boolean;
  prompt?: string;
  noDocumentText?: string;
  accept?: string;
  url?: string;
  raw?: boolean; //returns the raw result after uploading.  Useful when uploading to the covert handler
  versionedDocuments: any;
  maxSize?: number;
  maxCombinedSize?: number;
  minSize?: number;
  label?: string;
  error?: boolean;
  helperText?: string;
  onVersionedDocumentChange: (versionedDocument: any) => void;
  onVersionedDocumentDelete?: (versionedDocument: any) => void;
  onUploadError?: (err: string) => void;
  onFileReject?: (rejectedFiles: Array<any>) => void;
  minimal?: boolean;
  parse?: boolean;
  required?: boolean;
  readOnly?: boolean;
  onClick?: (fileName: string, storageKey: string, ea: any, newWindow?: boolean) => void;
}

type State = {
  prompt: string;
  accept: string;
  status: 'ready' | 'uploadingNewDocument' | 'uploadingNewVersion' | 'uploaded';
  uploadingNewVersionIDX?: number;
  historyAnchorEl?: any;
  error?: any;
};

class VersionedDocumentList extends React.Component<Props & WithStyles<keyof typeof styles>,State> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props);
    this.state = {
      status: 'ready',
      prompt: props.prompt || 'Drop file to upload new document',
      accept:
        props.accept ||
        'image/gif, image/jpeg, application/pdf, image/png, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, image/tiff, text/plain, text/csv, application/vnd.ms-outlook, message/rfc822, .msg'
    };
  }

  onDrop = (acceptedFiles: Array<any>, rejectedFiles: Array<any>) => {
    const { parse } = this.props;

    if (rejectedFiles && rejectedFiles.length > 0) {
      if (this.props.onFileReject) {
        this.props.onFileReject(rejectedFiles);
      }
      rejectedFiles.forEach((f: any) => {
        if (f.file.size > (this.props.maxSize || MAX_FILE_SIZE)) {
          this.setState({
            status: 'ready',
            error: `File size cannot exceed ${(
              (this.props.maxSize || MAX_FILE_SIZE) /
              (1024 * 1024)
            ).toFixed(0)}MB`
          });
          return
        }
      });
    }

    if (acceptedFiles && acceptedFiles.length > 0) {
      this.setState({ status: 'uploadingNewDocument' }, () => {
        const { versionedDocuments } = this.props;
        let vds = versionedDocuments;
        if (!vds || vds == '') {
          vds = {
            list: []
          };
        }

        if ((this.props.maxCombinedSize || 0) > 0) {
          // Prime the combined size (cs) with the file about to be added
          var cs = acceptedFiles[0].size;
          for (let f of (vds.list|| [])) {
              if (f && f.active) {
                  cs += (f.active.size || 0)
              }
          }
          // If the combined size exceeds the maxCombinedSize, abort and notify user
          if (cs > this.props.maxCombinedSize) {
              this.setState({
                  status: 'ready',
                  error: `Combined file size cannot exceed ${(
                      (this.props.maxCombinedSize) /
                      (1024 * 1024)
                  ).toFixed(0)}MB`
              });
              return;
          }
      }

        // OK, we have one or more accepted files
        let parseFlag = '';
        if (parse) {
          parseFlag = '?parse=true';
        }
        for (let f of acceptedFiles) {
          request
            .post((this.props.url || `/api/attachment-storage`) + parseFlag)
            .attach(f.name, f)
            .then((response) => {
              if (response.ok) {
                const att = {
                  active: {
                    fileName: f.name,
                    contentType: f.type,
                    size: f.size,
                    storageKey: response.body.storageKey,
                    data: response.body.data,
                    uploadedOn: new Date(),
                    uploadedBy: {
                      name: PortalUserContext.userContext.displayName,
                      email: PortalUserContext.userContext.email
                    }
                  },
                  priorVersions: []
                };

                if (!vds || vds == '') {
                  vds = {
                    list: []
                  };
                }
                if (!vds.list) {
                  vds.list = [];
                }

                vds.list.push(att);
                this.props.onVersionedDocumentChange(vds);
                this.setState({ status: 'ready', error: null });
              } else {
                if (this.props.onUploadError) {
                  this.props.onUploadError(response.body);
                }

                // Report the error to the user
                this.setState({
                  status: 'ready',
                  error: 'An error occurred uploading the document'
                });
              }
            })
            .catch((err) => {
              if (this.props.onUploadError) {
                this.props.onUploadError(err);
              }
              // Report the error to the user
              this.setState({
                status: 'ready',
                error: 'An error occurred uploading the document'
              });
            });
        }
      });
    }
  };

  onDropNewVersion = (
    index,
    acceptedFiles: Array<any>,
    rejectedFiles: Array<any>
  ) => {
    const { parse } = this.props;
    if (rejectedFiles && rejectedFiles.length > 0 && this.props.onFileReject) {
      this.props.onFileReject(rejectedFiles);
    }

    if (acceptedFiles && acceptedFiles.length > 0) {
      this.setState(
        { status: 'uploadingNewVersion', uploadingNewVersionIDX: index },
        () => {
          var { list } = this.props.versionedDocuments;
          var document = list[index];
          if (document) {
            let parseFlag = '';
            if (parse) {
              parseFlag = '?parse=true';
            }
            for (let f of acceptedFiles) {
              request
                .post((this.props.url || `/api/attachment-storage`) + parseFlag)
                .attach(f.name, f)
                .then((response) => {
                  if (response.ok) {
                    const att = {
                      fileName: f.name,
                      contentType: f.type,
                      size: f.size,
                      storageKey: response.body.storageKey,
                      data: response.body.data,
                      uploadedOn: new Date(),
                      uploadedBy: {
                        name: PortalUserContext.userContext.displayName,
                        email: PortalUserContext.userContext.email
                      }
                    };

                    document.priorVersions.push(document.active);
                    document.active = att;

                    this.props.onVersionedDocumentChange(
                      this.props.versionedDocuments
                    );
                    this.setState({
                      status: 'ready',
                      error: null,
                      uploadingNewVersionIDX: undefined
                    });
                  } else {
                    if (this.props.onUploadError) {
                      this.props.onUploadError(response.body);
                    }

                    // Report the error to the user
                    this.setState({
                      status: 'ready',
                      error: 'An error occurred uploading the document',
                      uploadingNewVersionIDX: undefined
                    });
                  }
                })
                .catch((err) => {
                  if (this.props.onUploadError) {
                    this.props.onUploadError(err);
                  }
                  // Report the error to the user
                  this.setState({
                    status: 'ready',
                    error: 'An error occurred uploading the document',
                    uploadingNewVersionIDX: undefined
                  });
                });
            }
          }
        }
      );
    }
  };

  onDelete = (idx: number, newWindow?: boolean) => (evt: any) => {
    const { versionedDocuments } = this.props;

    let vds = versionedDocuments;
    if (!vds || vds == '') {
      vds = {
        list: []
      };
    }

    vds.list.splice(idx, 1);

    this.setState({
      error: null
    }, () => {
      if (this.props.onVersionedDocumentChange) {
        this.props.onVersionedDocumentChange(vds);
      }
      if (this.props.onVersionedDocumentDelete) {
        this.props.onVersionedDocumentDelete(vds);
      }
    })
  };

  onClick = (fileName: string, storageKey: string, newWindow?: boolean) => (
    evt: any
  ) => {
    if (this.props.onClick) {
      this.props.onClick(fileName, storageKey, newWindow)
    } else {
      if (newWindow || this.props.alwaysOpenInNewWindow) {
        window.open(
          '/api/attachment-storage/' + storageKey + '/raw?fileName=' + fileName,
          '_blank'
        );
      } else {
        window.location.href =
          '/api/attachment-storage/' + storageKey + '/raw?fileName=' + fileName;
      }
    }
  };

  handleShowHistory = (event: any) => {
    this.setState({ historyAnchorEl: event.currentTarget });
  };

  handleHistoryClose = () => {
    this.setState({ historyAnchorEl: null });
  };

  handleHistorySelect = (storageKey: string, newWindow?: boolean) => () => {
    if (newWindow || this.props.alwaysOpenInNewWindow) {
      window.open('/api/attachment-storage/' + storageKey + '/raw', '_blank');
    } else {
      window.location.href = '/api/attachment-storage/' + storageKey + '/raw';
    }
    this.setState({ historyAnchorEl: null });
  };

  getFileInfo = (
    mimeType: string,
    classes: any
  ): { iconClass: string; newWindow: boolean } => {
    var iconClass: any;
    var newWindow: boolean;

    switch (mimeType) {
      case 'image/gif':
      case 'image/jpeg':
      case 'image/tiff':
      case 'image/png':
        iconClass = 'fa-file-image ' + classes.icon;
        newWindow = true;
        break;
      case 'application/pdf':
        iconClass = 'fa-file-pdf ' + classes.icon;
        newWindow = true;

        break;
      case 'application/msword':
      case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        iconClass = 'fa-file-word ' + classes.icon;
        newWindow = true;
        break;
      case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      case 'application/vnd.ms-excel':
        iconClass = 'fa-file-excel ' + classes.icon;
        newWindow = true;
        break;
      case 'text/plain':
        iconClass = 'fa-file-alt ' + classes.icon;
        newWindow = true;
        break;

      default:
        iconClass = 'fa-file ' + classes.icon;
        newWindow = true;
        break;
    }

    return { iconClass, newWindow };
  };

  render() {
    const self = this;
    const { classes }: { classes: ClassNameMap } = this.props;
    const {
      minSize,
      maxSize,
      preventDelete,
      // label,
      error,
      helperText,
      hideVersions,
      // minimal,
      disabled,
      noDocumentText,
      required,
      readOnly,
      dissallowNewVersions
    } = this.props;
    const { historyAnchorEl, status, uploadingNewVersionIDX } = this.state;
    var attachments;
    if (this.props.versionedDocuments && this.props.versionedDocuments != '') {
      attachments = this.props.versionedDocuments.list;
    }
    let dzClass = classes.dropzone
    let prompt = 'Drop file to upload new document';
    if (helperText) {
      if (helperText == 'Field required' || helperText == 'At least one document is required') {
        prompt = "At least one document is required"
        dzClass = classes.dropzoneError;
      } else {
        prompt = helperText
      }
    }
    if (this.state.error) {
      prompt = this.state.error
      dzClass = classes.dropzoneError;
    }
    if (required) {
      noDocumentText = (noDocumentText || 'No document uploaded') + ''
    }

    let iconClass = 'fa-file ' + classes.icon;

    let documentView = (
      <div className={classes.noDocument}>
        {noDocumentText || 'No document uploaded'}
      </div>
    );

    if (required) {
      documentView = (
        <div className={classes.noDocument}>
          {noDocumentText || 'No document uploaded'}<span className={classes.required}>&nbsp;*</span>
        </div>
      );

    }


    if (attachments && attachments.length > 0) {
      documentView = (
        <div>
          {attachments.map((attachment: any, idx) => {
            const { iconclass, newWindow } = self.getFileInfo(
              attachment.contenttype,
              classes
            );

            var newVersionDropZone: any;
            newVersionDropZone = (
              <Dropzone
                multiple={false}
                minSize={minSize}
                maxSize={maxSize || MAX_FILE_SIZE}
                accept={this.state.accept}
                className={classes.dropzoneMin}
                activeClassName={classes.dropzoneActive}
                rejectClassName={classes.dropzoneReject}
                disabledClassName={classes.dropzoneDisabled}
                onDrop={this.onDropNewVersion.bind(this, idx)}
                disabled={this.props.disabled || readOnly}>
                <Tooltip key="Upload" title="Upload New Version">
                  <IconButton name="uploadNewVersion" size="large">
                    <Icon>backup</Icon>
                  </IconButton>
                </Tooltip>
              </Dropzone>
            );

            if (
              status == 'uploadingNewVersion' &&
              uploadingNewVersionIDX == idx
            ) {
              newVersionDropZone = (
                <div className={classes.loading}>
                  <CircularProgress color={'inherit'} size={20} thickness={3} />
                </div>
              );
            }

            return (
              <div className={classes.document}>
                {!dissallowNewVersions && newVersionDropZone}
                {!hideVersions &&
                  PortalUserContext.hasOneOfFeatures([
                    'view_versioned_document_history'
                  ]) &&
                  attachment.priorVersions &&
                  attachment.priorVersions.length > 0 && (
                    <div>
                      <Tooltip key="history" title="Show prior versions">
                        <IconButton size="large" onClick={this.handleShowHistory}>
                          <Icon>history</Icon>
                        </IconButton>
                      </Tooltip>
                      <Menu
                        id="history-menu"
                        anchorEl={historyAnchorEl}
                        open={Boolean(historyAnchorEl)}
                        onClose={this.handleHistoryClose}>
                        <ListSubheader
                          color="primary"
                          className={classes.subheader}>
                          Prior Document Versions
                        </ListSubheader>
                        {attachment.priorVersions
                          .reduce((acc: Array<any>, v: any, idx: number) => {
                            if (!v) {
                              console.warn('null prior version, skipping');
                              return acc;
                            }
                            if (Object.keys(v).length == 0) {
                              console.warn('empty prior version, skipping');
                              return acc;
                            }
                            const { iconClass, newWindow } = self.getFileInfo(
                              v.contentType,
                              classes
                            );
                            const uploadedAt = moment(v.uploadedAt).format(
                              'MM/DD/YYYY hh:mm:ss a'
                            );
                            var secondary: any = null;
                            if (v.uploadedBy && v.uploadedBy.name) {
                              secondary =
                                'Uploaded ' +
                                uploadedAt +
                                ' by ' +
                                v.uploadedBy.name;
                            }
                            acc.push(
                              <MenuItem
                                key={idx}
                                onClick={this.onClick(
                                  v.fileName,
                                  v.storageKey,
                                  newWindow
                                )}>
                                <ListItemIcon className={classes.icon}>
                                  <i
                                    className={
                                      'far ' +
                                      iconClass +
                                      ' ' +
                                      classes.documentIcon
                                    }
                                  />
                                </ListItemIcon>
                                <ListItemText
                                  className={classes.text}
                                  inset
                                  primary={v.fileName}
                                  secondary={secondary}
                                />
                              </MenuItem>
                            );

                            return acc;
                          }, [])
                          .reverse()}
                      </Menu>
                    </div>
                  )}
                <Button
                  size="large"
                  color="inherit"
                  className={classes.documentFileName}
                  onClick={this.onClick(
                    attachment.active.fileName,
                    attachment.active.storageKey,
                    newWindow
                  )}>
                  <i
                    className={'far ' + iconClass + ' ' + classes.documentIcon}
                    onClick={this.onClick(
                      attachment.active.fileName,
                      attachment.active.storageKey,
                      newWindow
                    )}
                  />
                  {attachment.active.fileName}
                </Button>
                {!preventDelete && !readOnly && (
                  <IconButton
                    size="large"
                    className={classes.deleteButton}
                    aria-label="delete"
                    onClick={this.onDelete(idx, newWindow)}>
                    <Icon>delete</Icon>
                  </IconButton>
                )}
              </div>
            );
          })}
        </div>
      );
    }
    
    var dropZone;
    dropZone = (
      <Dropzone
        multiple={false}
        minSize={minSize}
        maxSize={maxSize || MAX_FILE_SIZE}
        accept={this.state.accept}
        className={dzClass}
        activeClassName={classes.dropzoneActive}
        rejectClassName={classes.dropzoneReject}
        disabledClassName={classes.dropzoneDisabled}
        onDrop={this.onDrop}
        disabled={this.props.disabled || readOnly}>
        {(state: {
          isDragActive: boolean;
          isDragReject: boolean;
          acceptedFiles: Array<any>;
          rejectedFiles: Array<any>;
          draggedFiles: Array<any>;
        }) => {
          if (state.isDragReject) {
            if (state.rejectedFiles.length > 1 && !this.props.multiple) {
              prompt = 'Multiple file drop is not permitted';
            } else {
              prompt = 'This file is not acceptable';
            }
          }
          if (disabled && !attachments) {
            prompt = 'Not Uploaded';
          }
          return (
            <div className={dzClass}>
              {prompt}
            </div>
          )
        }}
      </Dropzone>
    );

    if (status == 'uploadingNewDocument') {
      dropZone = (
        <div className={classes.loading}>
          <CircularProgress color={'inherit'} size={20} thickness={3} />
        </div>
      );
    }

    if (disabled || readOnly) {
      dropZone = null;
    }

    return (
      <div style={{ display: 'inline-block' }} >
        {dropZone}
        {documentView}
      </div>
    );
  }
}

export default withStyles(styles)(VersionedDocumentList);